import React, { useState } from 'react';
import { FaWhatsapp, FaLine, FaPhone, FaChevronDown  } from 'react-icons/fa';
import { LuMessageCircleMore } from 'react-icons/lu';
import { useTranslation } from 'react-i18next'; // <-- import

const ContactArrowPopup = () => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation(); // <-- ใช้ t

  return (
    <div style={styles.container}>
      {open && (
        <div style={styles.menu}>
          <a href="https://wa.me/+66935818543" target="_blank" rel="noopener noreferrer" style={{ ...styles.contactButton, backgroundColor: '#25D366' }}>
            <FaWhatsapp size={20} />
          </a>
          <a href="https://line.me/R/ti/p/@summerhouseagent" target="_blank" rel="noopener noreferrer" style={{ ...styles.contactButton, backgroundColor: '#00C300' }}>
            <FaLine size={20} />
          </a>
          <a href="tel:+66 93 581 8543" style={{ ...styles.contactButton, backgroundColor: '#2980B9' }}>
            <FaPhone size={20} />
          </a>
        </div>
      )}

      <button onClick={() => setOpen(!open)} style={styles.button}>
          {open ? (
            <FaChevronDown size={24} /> // แสดงลูกศรลงเมื่อเปิด
          ) : (
            <LuMessageCircleMore
              size={24}
              style={{
                transition: 'transform 0.3s',
                transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
              }}
            />
          )}
          {!open && (
            <div style={styles.notificationBox}>
              {t('Hi !')}
            </div>
          )}
        </button>
    </div>
  );
};

const styles = {
  container: {
    position: 'fixed',
    right: '20px',
    bottom: '20px',
    display: 'flex',
    flexDirection: 'column-reverse',
    alignItems: 'center',
    gap: '10px',
    zIndex: 9999,
  },
  button: {
    position: 'relative',
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#fff',
    backgroundColor: '#dd9e2a',
    boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
    cursor: 'pointer',
    border: 'none',
    
  },
  
  
  notificationBox: {
    position: 'absolute',
    top: '-10px',
    right: '-10px',
    backgroundColor: 'red',
    color: '#fff',
    fontSize: '12px',
    fontWeight: 'bold',
    padding: '2px 6px',
    borderRadius: '8px',
    boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
    animation: 'pulseBox 1.5s infinite',
  },
  menu: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    marginBottom: '10px',
  },
  contactButton: {
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#fff',
    boxShadow: '0 3px 8px rgba(0,0,0,0.2)',
    cursor: 'pointer',
    textDecoration: 'none',
  },
};

/* CSS Keyframes สำหรับ pulse */
const styleSheet = document.styleSheets[0];
const keyframes =
  `@keyframes pulseBox {
    0% { transform: scale(1); opacity: 1; }
    50% { transform: scale(1.2); opacity: 0.8; }
    100% { transform: scale(1); opacity: 1; }
  }`;
styleSheet.insertRule(keyframes, styleSheet.cssRules.length);

export default ContactArrowPopup;
